// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tier-main-container .more-action {\n  font-size: 20px !important;\n  font-weight: bold !important;\n}", "",{"version":3,"sources":["webpack://./src/commonPages/demo/tier/TierData.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B","sourcesContent":[".tier-main-container .more-action {\n  font-size: 20px !important;\n  font-weight: bold !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
